export default __webpack_public_path__ + "static/media/candidate.work_learn_tab.hospitality.60d89947.jpg";